import { UseMileageRatesResponse } from './useMileageRates.interface';

import collectiveApi from 'modules/common/collectiveApi';

const fetchMileageRates = async (): Promise<UseMileageRatesResponse> => {
    const { data } = await collectiveApi.get<UseMileageRatesResponse>('bookkeeping/irsmileagerates/');
    return data;
};

export default fetchMileageRates;
